<template>
  <div class="relative">
    <div v-show="!showAddFileDesktop">
      <div class="custom-color-gray w-full flex min-h-viewer max-h-viewer border rounded-t py-10 overflow-auto">
        <div class="flex flex-wrap items-center justify-center">
          <template v-for="(item, index) in state.documentsToUpload">
            <div :key="index" class="w-1/2 mb-4 flex justify-center">
              <div :class="['mx-auto h-preview max-h-preview bg-white rounded border border-gray-500 relative', item.mimeType === 'application/pdf' ? 'is-pdf' : 'w-2/3']">
                <div class="absolute custom-position z-50">
                  <zt-button fab icon="trash-outline" outlined @click="deleteChoosenFile(index)" />
                </div>
                <div class="preview-wrapper">
                  <div
                    v-if="item.mimeType === 'image/png' || item.mimeType === 'image/jpeg' || item.mimeType === 'image/jpg'">
                    <img class="max-h-img mx-auto z-0" :src="item.file.UrlOnLoad" :alt="index" />
                  </div>
                  <div v-else-if="item.mimeType === 'application/pdf'" class="pdf-thumb">
                    <zt-pdf-viewer
                      :key="`pdf-${index}-${viewportWidth}`"
                      :ref="`ztPDFViewer_${index}`"
                      :src="item.file.UrlOnLoad"
                      :page="1"
                      :show-control="false"
                      class="z-0"
                      @page-count="fitPdfThumb(index)"
                    ></zt-pdf-viewer>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="h-16 border rounded-b bg-purple-700 cursor-pointer -mt-1" @click="appendNewFileToMetadata">
        <div class="flex flex-col">
          <div class="flex items-center justify-center text-white text-zt-xl pt-2">
            <zt-icon name="add-file" class="pr-2" />
            <span>
              {{ $t("message.FileUploadComponent.formComponent.addNewField") }}
            </span>
          </div>
        </div>
      </div>
      <zt-overlay :active="activeOverlay" :z-index="99">
        <PickersWrapper :openWindow="openWindow" />
      </zt-overlay>
    </div>
    <div v-show="showAddFileDesktop">
      <div class="absolute custom-position-close z-50">
        <zt-button fab icon="times" outlined @click="changeAddFileDesktop(false)" />
      </div>
      <FilePickerDesktop :openWindow="openWindow" @close-loadfile="changeAddFileDesktop(false)" />
    </div>
  </div>
</template>

<script>
import PickersWrapper from './PickersWrapper'
import { useWindowResize } from '@sichern/ui-elements'
import FilePickerDesktop from './FilePickerDesktop.vue'

export default {
  inject: ['state', 'mutations'],
  props: ['openWindow'],
  components: {
    PickersWrapper,
    FilePickerDesktop
  },
  data() {
    return {
      documents: this.state.documentsToUpload,
      windowResize: useWindowResize(this),
      showAddFileDesktop: false
    }
  },
  computed: {
    activeOverlay() {
      return this.state.activeOverlay
    },
    viewportWidth() {
      return this.windowResize.width
    }
  },
  created() {
    this.state.documentsToUpload.forEach(element => {
      let renderImage = { 'UrlOnLoad': URL.createObjectURL(element.file) }
      element.file = Object.assign(element.file, renderImage)
    });
  },
  methods: {
    deleteChoosenFile(index, item) {
      this.mutations.deleteDocument(index)
    },
    appendNewFileToMetadata() {
      if (this.state.documentsToUpload.length + 1 <= this.state.metadata.json.max_files) {
        if (this.windowResize.width < 1023) {
          this.mutations.setActiveOverlay(true)
        } else {
          this.changeAddFileDesktop(true)
        }
      } else {
        this.$swal({
          type: "error",
          title: this.$t("message.FileUploadComponent.swal.titleUploadViewer"),
          showConfirmButton: true,
          confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
        });
      }
    },
    changeAddFileDesktop(value) {
      this.showAddFileDesktop = value
    },
    fitPdfThumb(index) {
      this.$nextTick(() => {
        const ref = this.$refs[`ztPDFViewer_${index}`]
        const viewer = Array.isArray(ref) ? ref[0] : ref
        if (viewer && typeof viewer.zoom === 'function') {
          viewer.zoom('page-fit')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.min-h-viewer {
  min-height: 17rem;
}

.max-h-viewer {
  max-height: 24rem;
}

.h-preview.is-pdf {
  width: clamp(85px, 100%, 130px);
  max-width: 130px;
  height: auto;
  aspect-ratio: 1 / 1.414;
}

.h-preview.is-pdf.max-h-preview {
  max-height: none;
}

.preview-wrapper {
  height: 100%;
  width: 100%;
}

.pdf-thumb {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

::v-deep .pdf-thumb .zt-pdf-viewer,
::v-deep .pdf-thumb [class*="zt-pdf-viewer"] {
  overflow: hidden !important;
}

::v-deep .pdf-thumb .zt-pdf-viewer-page,
::v-deep .pdf-thumb .zt-pdf-viewer-page > div {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden;
}

::v-deep .pdf-thumb .page,
::v-deep .pdf-thumb .canvasWrapper {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  overflow: hidden;
}

::v-deep .pdf-thumb canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: contain;
}

@media screen and (min-width: 1024px) {

  // desktop
  .custom-position {
    top: -20px;
    left: 60px;
  }

  .custom-position-close {
    top: -10px;
    left: calc(100% - 25px);
  }

  .h-preview {
    height: 12rem;
  }

  .max-h-preview {
    max-height: 12rem;
  }

  .max-h-img {
    max-height: 11rem;
  }
}

@media screen and (max-width: 1023px) {

  //Mobile
  .custom-position {
    top: -20px;
    left: 75px;
  }

  .h-preview {
    height: 11rem;
  }

  .max-h-preview {
    max-height: 11rem;
  }

  .max-h-img {
    max-height: 10rem;
  }
}

.custom-color-gray {
  background: #e0e0e0;
}
</style>